/**
 * Ajout AGORA (absent du bundle de référence) – SkipLink : lien d'évitement « Aller au contenu » (WCAG 2.4.1, contourner
 * des blocs). Premier élément focalisable d'un écran : masqué tant qu'il n'a pas le focus, il apparaît en haut à gauche
 * à la première tabulation (pastille `brand`, contour `focus-ring` ; styles `agx-evitement` dans
 * core/accessibilite.css) ; Entrée amène le focus dans le contenu principal, après la barre latérale et l'en-tête.
 *
 * Le focus est réellement déplacé (pas seulement le défilement) : la cible doit pouvoir le recevoir (`tabIndex={-1}`,
 * posé ici s'il manque) ; la tabulation suivante part donc du contenu. `href="#<targetId>"` reste le repli sans
 * script ; avec script, l'adresse n'est pas modifiée (pas d'entrée d'historique ni de `#` dans l'URL de la page).
 * `getTarget` désigne une cible plus précise que l'élément `targetId` (ex. la page active de l'espace de travail).
 * Libellé fourni traduit par l'appelant (`nav.allerAuContenu`).
 */
import React from 'react';
import { h } from './base';

export interface SkipLinkProps {
  /** Libellé traduit (« Aller au contenu »). */
  label: string;
  /** Identifiant du contenu principal (`<main id>`) : lien et cible par défaut. */
  targetId: string;
  /** Cible effective du focus, si plus précise que l'élément `targetId` ; null → `targetId`. */
  getTarget?: () => HTMLElement | null;
}

export function SkipLink(p: SkipLinkProps) {
  const activer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const cible = p.getTarget?.() ?? document.getElementById(p.targetId);
    if (!cible) return;
    e.preventDefault();
    if (!cible.hasAttribute('tabindex')) cible.tabIndex = -1;
    cible.focus();
  };
  return h('a', { className: 'agx-evitement', href: `#${p.targetId}`, onClick: activer }, p.label);
}
